export const parametrosKeys = {
  parametros: ['parametros'] as const,
  simulacao: (idExternoEmpreendimento: string) =>
    [...parametrosKeys.parametros, 'empreendimento', idExternoEmpreendimento, 'simulacao'] as const,
  proposta: (idExternoEmpreendimento?: number) =>
    [...parametrosKeys.parametros, 'empreendimento', idExternoEmpreendimento, 'proposta'] as const,
}
